{
  "markets": {
    "title": "ประเทศและสกุลเงิน",
    "intro": "เว็บขายไปประเทศไหน ใช้สกุลเงินอะไร และภาษี/ภาษีนำเข้าของแต่ละกลุ่มประเทศเป็นอย่างไร",
    "read_only": "แสดงเพื่อดูอย่างเดียว ภาษีนำเข้าแก้ที่ ค่าส่ง → ภาษีนำเข้า; ภาษาของเว็บแก้ที่ ภาษาของเว็บ",
    "to_duties": "แก้ภาษีนำเข้า",
    "to_languages": "ภาษาของเว็บ",
    "error": "โหลดรายการประเทศไม่ได้",
    "empty": "ยังไม่ได้ตั้งประเทศ",
    "default": "หลัก",
    "on": "เปิดขาย",
    "off": "ปิดขาย",
    "rest_of_world": "ประเทศอื่นทั้งหมด",
    "countries_more_other": "{{list}} และอีก {{count}} ประเทศ",
    "currency": "สกุลเงิน",
    "fixed_rate": "1 เยน = {{rate}} {{currency}}",
    "fx": {
      "own_table": "อัตราแลกเปลี่ยนของร้าน",
      "fixed": "อัตราคงที่",
      "stripe_adaptive": "แปลงโดยบริการรับบัตร (เฟสถัดไป)"
    },
    "tax": "ภาษีบริโภค",
    "tax_mode": {
      "domestic": "ราคารวมภาษีบริโภค 10%",
      "export": "ส่งออก — ไม่มีภาษีบริโภคญี่ปุ่น"
    },
    "duties": "ภาษีนำเข้า",
    "duties_none": "ไม่มี (ขายในญี่ปุ่น)",
    "duties_mode": {
      "DDU": "ลูกค้าจ่ายเองตอนของถึง (ประมาณ {{rate}}%)",
      "DDP": "เก็บตอนสั่งซื้อ ({{rate}}%)"
    },
    "free_shipping": "ส่งฟรีเมื่อซื้อถึง",
    "free_shipping_none": "ยังไม่ตั้ง"
  },
  "domains": {
    "title": "ที่อยู่เว็บ (โดเมน)",
    "intro": "ที่อยู่ของเว็บ หน้าหลังบ้านนี้ และเครื่องคิดเงิน — ดูอย่างเดียว ฝ่าย IT เป็นคนเปลี่ยน",
    "website": "เว็บ (ลูกค้า)",
    "admin": "หลังบ้าน (หน้านี้)",
    "register": "เครื่องคิดเงิน (หน้าร้าน)",
    "copy": "คัดลอก",
    "copied": "คัดลอกที่อยู่แล้ว",
    "copy_failed": "คัดลอกไม่ได้ — เลือกที่อยู่แล้วคัดลอกเอง",
    "how_to_change": "ถ้าจะใช้โดเมนใหม่ ให้บอกฝ่าย IT (ตั้งครั้งเดียวกับบริษัทโดเมนและเซิร์ฟเวอร์)"
  },
  "lang": {
    "ja": "日本語",
    "en": "English"
  },
  "store": {
    "title": "ข้อมูลร้าน",
    "intro": "กรอกข้อมูลร้านครั้งเดียว — ใช้ในหน้ากฎหมายของเว็บ และท้ายอีเมลทุกฉบับ",
    "needs_content": "เปิดข้อมูลร้านได้เฉพาะพนักงานที่แก้เนื้อหาเว็บได้",
    "error": "โหลดข้อมูลร้านไม่ได้",
    "facts_title": "เกี่ยวกับร้าน",
    "facts_intro": "ภาษาญี่ปุ่นกฎหมายบังคับ ภาษาอังกฤษแสดงให้ลูกค้าต่างประเทศ",
    "read_only": "เฉพาะเจ้าของร้านแก้ข้อมูลร้านได้ คุณดูได้อย่างเดียว",
    "kobutsu_title": "ใบอนุญาตค้าของมือสอง (古物商許可)",
    "fields": {
      "shopName": "ชื่อร้าน / บริษัท (販売業者)",
      "representative": "ผู้รับผิดชอบ (代表者)",
      "address": "ที่อยู่ (所在地)",
      "phone": "โทรศัพท์",
      "phoneHours": "เวลารับโทรศัพท์",
      "email": "อีเมลสำหรับลูกค้า",
      "website": "ที่อยู่เว็บ",
      "commission": "คณะกรรมการความปลอดภัยสาธารณะ (公安委員会)",
      "licenseNumber": "เลขใบอนุญาต (古物商許可番号)",
      "nameKana": "ชื่อร้านแบบคาตาคานะ (フリガナ)",
      "postalCode": "รหัสไปรษณีย์ (〒)"
    },
    "help": {
      "shopName": "ชื่อตามใบอนุญาตและใบเสร็จ — ชื่อบริษัทหรือชื่อตัวเอง",
      "representative": "คนที่รับผิดชอบร้าน",
      "address": "ที่ตั้งร้าน ลูกค้าต้องติดต่อได้ที่นี่",
      "phone": "เบอร์ที่ลูกค้าโทรได้",
      "phoneHours": "เวลาที่รับสาย เช่น 11:00–19:00 หยุดวันอังคาร",
      "email": "ที่ลูกค้าเขียนถึง แสดงในอีเมลด้วย",
      "website": "ที่อยู่เว็บ ขึ้นต้นด้วย https://",
      "commission": "หน่วยที่ออกใบอนุญาต เช่น 東京都公安委員会",
      "licenseNumber": "เลขบนใบอนุญาต (12 หลัก) ต้องแสดงบนเว็บ",
      "nameKana": "คำอ่านชื่อร้านเป็นคาตาคานะ เช่น カードショップトウキョウ",
      "postalCode": "ตัวเลข 7 หลัก เช่น 150-0001 จะแสดงหน้าที่อยู่ในหน้าข้อกฎหมาย"
    },
    "problems": {
      "email": "ไม่ใช่รูปแบบอีเมล",
      "phone": "ใช้ตัวเลข ช่องว่าง + หรือ - เท่านั้น",
      "website": "ขึ้นต้นด้วย https://",
      "postalCode": "ใส่ตัวเลข 7 หลัก เช่น 150-0001",
      "nameKana": "ใช้ตัวคาตาคานะเท่านั้น (เช่น カードショップ)",
      "licenseNumber": "ใส่ตัวเลขเท่านั้น เช่น 第301012345678号 (เลขบนใบอนุญาต 古物商許可証)"
    },
    "save": "บันทึกข้อมูลร้าน",
    "undo": "ยกเลิกที่แก้",
    "saved": "บันทึกแล้ว กด \"อัปเดตหน้าบนเว็บ\" ข้างล่างเพื่อให้ลูกค้าเห็นข้อมูลใหม่",
    "saved_no_footer": "บันทึกในหน้ากฎหมายแล้ว แต่อัปเดตท้ายอีเมลไม่ได้ — ลองบันทึกอีกครั้งภายหลัง",
    "part_footer": "ท้ายอีเมล",
    "saved_parts": "บันทึกแล้ว: {{parts}}",
    "not_saved": "ยังไม่ได้บันทึก: {{parts}} — ลองบันทึกอีกครั้ง",
    "not_saved_conflict": "ยังไม่ได้บันทึก: {{parts}} — มีคนแก้ก่อน กด \"โหลดล่าสุด\" หรือตรวจแล้วบันทึกอีกครั้ง",
    "conflict": "มีคนแก้หน้าเหล่านี้ก่อน แสดงข้อมูลล่าสุดแล้ว — แก้อีกครั้ง",
    "payments_used": "อัปเดตวิธีชำระเงินตามการตั้งค่าการรับเงินแล้ว",
    "where_used": "ใช้ที่: ด้านบนของหลังร้าน, ใบเสร็จ, 特定商取引法に基づく表記, 古物営業法に基づく表示, หน้าติดต่อ, ท้ายอีเมล",
    "tax_title": "การจดทะเบียนภาษี",
    "to_tax": "เปิดการตั้งค่าภาษี",
    "tax_error": "โหลดการตั้งค่าภาษีไม่ได้",
    "t_number": "เลขทะเบียน (T-number)",
    "t_number_missing": "ยังไม่ได้กรอก",
    "business_name": "ชื่อที่จดทะเบียน",
    "business_type": "รูปแบบธุรกิจ",
    "business_types": {
      "individual": "บุคคลธรรมดา (個人事業主)",
      "corporation": "นิติบุคคล (法人)"
    },
    "not_decided": "ยังไม่ตัดสินใจ",
    "tax_free": "ขายปลอดภาษี (免税)",
    "tax_free_yes": "มีใบอนุญาต",
    "tax_free_no": "ไม่มีใบอนุญาต",
    "logo_title": "โลโก้ร้าน",
    "logo_help": "แสดงด้านบนของหลังร้านให้ทุกคนเห็น เลือกรูปจากคลังรูปภาพ",
    "logo_choose": "เลือกรูป",
    "logo_change": "เปลี่ยนรูป",
    "logo_remove": "เอาโลโก้ออก",
    "logo_none": "ยังไม่มีโลโก้ — จะแสดงชื่อร้านแทน",
    "logo_picker": "เลือกโลโก้ร้าน",
    "not_saved_record": "ข้อมูลร้านยังไม่ถูกบันทึก — มีคนอื่นแก้ก่อน กดโหลดล่าสุดแล้วลองอีกครั้ง",
    "record_error": "บันทึกข้อมูลร้านไม่ได้ ไม่มีอะไรถูกเปลี่ยน",
    "signage": {
      "title": "ป้ายสำหรับพิมพ์",
      "intro": "สร้าง PDF จากข้อมูลร้านด้านบน พิมพ์ขนาดจริง (100%) แล้ววัดด้วยไม้บรรทัดหนึ่งครั้ง",
      "hyoshiki": "ป้ายร้านรับซื้อของมือสอง (標識 8×16 ซม.)",
      "identity": "ป้ายขอดูบัตรประจำตัวที่เคาน์เตอร์ (A4)",
      "needs_permit": "ป้าย 標識 ต้องมีเลขใบอนุญาต (12 หลัก) ชื่อคณะกรรมการความปลอดภัยสาธารณะ และชื่อร้านด้านบนก่อน"
    }
  },
  "tokushoho": {
    "title": "หน้าแจ้งข้อมูลตามกฎหมาย (特定商取引法に基づく表記)",
    "ring": "กรอกแล้ว {{filled}} จาก {{total}} ข้อ",
    "filled": "มีข้อความภาษาญี่ปุ่นแล้ว {{filled}} จาก {{total}} ข้อ",
    "all_done": "กรอกครบทั้ง 14 ข้อแล้ว",
    "law_link": "กฎหมายกำหนดอะไร (消費者庁)",
    "fill": "กรอกข้อมูล",
    "returns_missing": "⑪ เงื่อนไขการคืนของ (返品特約) ยังว่าง ถ้าไม่แสดง ผู้ซื้อยกเลิกได้ภายใน 8 วันหลังได้รับของ (特商法 15条の3)",
    "returns_guide": "แนวทาง",
    "payments_differ": "⑧ วิธีชำระเงินไม่ตรงกับวิธีรับเงินที่เปิดอยู่: “{{text}}”",
    "use_payments": "ใช้ข้อความนี้",
    "license_missing": "เลข 古物商許可番号 ยังว่าง — ต้องแสดงบนเว็บ (古物営業法) ยังขายได้ตามปกติ",
    "kobutsu_link": "เกี่ยวกับใบอนุญาต (警視庁)",
    "still_empty": "ยังว่าง:",
    "item_label": "{{no}}. {{label}}",
    "items": {
      "seller": {
        "label": "ผู้ขาย",
        "help": "ชื่อร้านหรือบริษัท"
      },
      "representative": {
        "label": "ผู้รับผิดชอบ",
        "help": "ชื่อผู้แทน"
      },
      "address": {
        "label": "ที่อยู่",
        "help": "ที่ตั้งธุรกิจ"
      },
      "phone": {
        "label": "โทรศัพท์และเวลา",
        "help": "เบอร์และเวลารับสาย"
      },
      "email": {
        "label": "อีเมล",
        "help": "ที่ลูกค้าเขียนถึง"
      },
      "price": {
        "label": "ราคา",
        "help": "วิธีแสดงราคา (รวมภาษี)"
      },
      "other_fees": {
        "label": "ค่าใช้จ่ายอื่น",
        "help": "ค่าส่ง ค่าโอน ภาษีนำเข้าต่างประเทศ"
      },
      "payment_methods": {
        "label": "วิธีชำระเงิน",
        "help": "วิธีรับเงินที่เปิดอยู่"
      },
      "payment_timing": {
        "label": "เวลาชำระ",
        "help": "เช่น ภายใน 3 วันหลังสั่ง"
      },
      "delivery_timing": {
        "label": "เวลาส่งของ",
        "help": "ใช้เวลาเตรียมและส่งกี่วัน"
      },
      "returns": {
        "label": "การคืนของ (返品特約)",
        "help": "อะไรคืนได้ ภายในเมื่อไร"
      },
      "quantity": {
        "label": "จำกัดจำนวน",
        "help": "เช่น 1 ใบต่อคน"
      },
      "other": {
        "label": "อื่น ๆ",
        "help": "เรื่องอื่นที่ลูกค้าควรรู้"
      },
      "validity": {
        "label": "อายุคำสั่งซื้อ / ยกเลิก",
        "help": "เก็บออเดอร์ที่ยังไม่จ่ายไว้นานเท่าไร"
      }
    },
    "what_items": "14 ข้อคืออะไร"
  },
  "publish": {
    "title": "เผยแพร่บนเว็บ",
    "pages": {
      "tokushoho": "特定商取引法に基づく表記",
      "kobutsu": "古物営業法に基づく表示",
      "contact": "ติดต่อ"
    },
    "published_on": "อยู่บนเว็บตั้งแต่",
    "not_published": "ยังไม่อยู่บนเว็บ",
    "changes_waiting": "มีที่แก้ยังไม่เผยแพร่",
    "save_first": "ยังมีข้อมูลร้านที่ไม่ได้บันทึก — บันทึกก่อนแล้วค่อยเผยแพร่",
    "missing": "“{{page}}” ยังขึ้นเว็บไม่ได้ — ข้อเหล่านี้ยังว่าง:",
    "button": "อัปเดตหน้าบนเว็บ (表記ページを更新)",
    "needs_permission": "ผู้จัดการหรือเจ้าของร้านเป็นคนเผยแพร่",
    "nothing": "ทุกหน้าอยู่บนเว็บแล้ว",
    "done": "ขึ้นเว็บแล้ว: {{pages}}",
    "confirm_title": "อัปเดตหน้ากฎหมายบนเว็บ?",
    "confirm_body": "ลูกค้าจะเห็นข้อความใหม่ของ: {{pages}} เขียนว่าเปลี่ยนอะไร — เก็บไว้ในประวัติของหน้า",
    "confirm": "อัปเดตหน้า",
    "show_preview": "ดูหน้าแบบที่ลูกค้าเห็น",
    "hide_preview": "ซ่อนหน้า",
    "preview_title": "หน้าแจ้งข้อมูลตามกฎหมายบนเว็บ",
    "history": "ฉบับก่อนหน้า",
    "version": "ฉบับที่ {{version}}"
  },
  "policy_fields": {
    "business_name": "ผู้ขาย",
    "representative": "ผู้รับผิดชอบ",
    "address": "ที่อยู่",
    "phone": "โทรศัพท์",
    "phone_hours": "เวลารับโทรศัพท์",
    "email": "อีเมล",
    "url": "เว็บ",
    "price_display": "ราคา",
    "additional_fees": "ค่าใช้จ่ายอื่น",
    "payment_methods": "วิธีชำระเงิน",
    "payment_timing": "เวลาชำระ",
    "delivery_timing": "เวลาส่งของ",
    "return_policy": "การคืนของ",
    "quantity_limit": "จำกัดจำนวน",
    "application_validity": "อายุคำสั่งซื้อ",
    "kobutsu_license": "古物商許可",
    "other_notes": "อื่น ๆ",
    "licensee_name": "ผู้ถือใบอนุญาต",
    "commission_name": "公安委員会",
    "license_number": "เลขใบอนุญาต",
    "notified_url": "เว็บที่แจ้งไว้",
    "hours": "เวลาทำการ",
    "body": "ข้อความของหน้า"
  },
  "web_orders": {
    "title": "ขั้นตอนสั่งซื้อ",
    "intro": "การรับออเดอร์บนเว็บไซต์",
    "error": "อ่านสถานะสวิตช์ไม่ได้ในขณะนี้",
    "switch_title": "รับออเดอร์บนเว็บไซต์",
    "state_open": "รับออเดอร์อยู่",
    "state_paused": "หยุดชั่วคราว",
    "explain_open": "ลูกค้าสั่งซื้อบนเว็บได้ตามปกติ — กดหยุดเมื่อมีปัญหา (ราคาผิด สต็อกมีปัญหา ร้านปิดชั่วคราว)",
    "explain_paused": "เว็บแสดงประกาศว่าหยุดรับออเดอร์ชั่วคราว ลูกค้ายังดูสินค้าได้แต่สั่งซื้อไม่ได้ — หน้าร้าน/POS ไม่ถูกกระทบ",
    "pause": "หยุดรับออเดอร์ชั่วคราว",
    "resume": "เปิดรับออเดอร์อีกครั้ง",
    "confirm_title": "หยุดรับออเดอร์บนเว็บชั่วคราว?",
    "confirm_body": "ลูกค้าจะเห็นประกาศและสั่งซื้อไม่ได้จนกว่าจะเปิดอีกครั้ง ออเดอร์ที่สั่งไปแล้วไม่เปลี่ยน",
    "paused_done": "หยุดรับออเดอร์บนเว็บแล้ว",
    "resumed_done": "เปิดรับออเดอร์บนเว็บอีกครั้งแล้ว",
    "who_can": "เฉพาะเจ้าของร้านหรือผู้จัดการเท่านั้นที่เปลี่ยนได้"
  }
}
